var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-manager-tree-node-attributes-control',{attrs:{"tree-node-id":_vm.treeNodeId,"collapse-disabled":"","hide-title":""}})}
var staticRenderFns = []

export { render, staticRenderFns }